var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"null-box"},[_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('../assets/null-data.png'),"description":"暂无数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }